<template>
  <div class="grid">
    <div @click="plusClicked">
      <img
        src="../assets/plus-circle.png"
        alt="Add button"
        class="plus-button"
        :class="buttonType"
      />
    </div>
    <div v-for="(item, i) in items" :key="i">
      <div class="item-container">
        <img
          @click="itemClicked(item, i)"
          :class="itemClass"
          :src="type === 'images' ? item.url : item.iconSrc"
          :alt="item.alt"
        />
        <!-- If any node is added/removed from the div below => need to refactor function setNameToolTip  -->
        <div v-if="type === 'icons'">
          <div class="display-name">
            {{ item.display }}
          </div>
          <div class="hide display-name" v-tooltip.top="item.display">
            {{ item.display }}
          </div>
          <div class="buttons-container">
            <i
              @click="editClicked(item, i)"
              class="pi pi-pencil action-icon"
            ></i>
            <i
              @click="deleteClicked(item, i)"
              class="pi pi-trash action-icon"
            ></i>
          </div>
        </div>
      </div>
    </div>
  </div>
  <input
    ref="fileInput"
    type="file"
    :multiple="multiple"
    @input="itemsSelected"
  />
</template>

<style lang="scss" scoped>
.grid {
  display: grid;
  gap: 1rem;
  grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
}
.container {
  max-width: 100%;
  flex-wrap: wrap;
}

.item-container {
  position: relative;

  &:hover {
    .action-icon {
      opacity: 1;
    }

    .buttons-container {
      top: 0;
    }
  }
}

.display-name {
  position: absolute;
  bottom: 1rem;
  font-size: 1.5rem;
  width: 90%;
  margin: 0 5%;
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: default;
}

.action-icon {
  padding: 0.5rem;
  border-radius: 50%;
  font-size: 1.3rem;
  cursor: pointer;
  color: #ffffff;
  opacity: 0;
  transition: opacity $animation-fast;

  &:not(:first-child) {
    margin-top: 0.5rem;
  }
}

.buttons-container {
  position: absolute;
  top: -30px;
  right: 0;
  margin: 0.5rem;
  display: flex;
  flex-direction: column;
  transition: top $animation-fast;

  .pi-trash {
    background-color: rgba(211, 47, 47, 0.7);
  }
  .pi-pencil {
    background-color: rgba(33, 150, 243, 0.7);
  }
}

.plus-button {
  border-radius: 3px;
  background-color: #e0e0e0;
}
img {
  width: 100%;
  cursor: pointer;
  border-radius: 3px;
  border: 1px solid #cecece;
}
.image {
  aspect-ratio: 4/3;
  object-fit: cover;
}

.icon {
  padding: 20px 40px 60px 40px;
}

input {
  display: none;
}
</style>

<script>
import { ref, computed, onMounted } from "vue";
import Tooltip from "primevue/tooltip";
export default {
  props: {
    items: {
      required: true
    },
    customPlusAction: {
      required: false,
      type: Boolean,
      default: false
    },
    type: {
      required: true,
      type: String,
      validator: val => {
        return val === "images" || val === "icons";
      }
    },
    multiple: {
      required: false,
      default: false,
      type: Boolean
    },
    uploadOnEntry: {
      required: false,
      type: Boolean,
      default: false
    }
  },
  directives: {
    tooltip: Tooltip
  },
  emits: [
    "item-clicked",
    "selected",
    "delete-item",
    "edit-item",
    "custom-plus-action"
  ],
  setup(props, context) {
    const fileInput = ref(null);
    onMounted(() => {
      if (props.uploadOnEntry) {
        console.log("do nothing");
      }

      const displayNames = document.getElementsByClassName("display-name");
      displayNames.forEach(el => {
        el.onmouseover = setNameToolTip;
      });
    });

    function setNameToolTip(ev) {
      const el = ev.target;
      if (el.offsetWidth < el.scrollWidth) {
        const siblings = el.parentNode.childNodes;
        siblings[0].classList.add("hide");
        siblings[1].classList.remove("hide");
      }
    }

    function plusClicked(ev) {
      if (!props.customPlusAction) {
        fileInput.value.click();
      } else {
        context.emit("custom-plus-action", ev);
      }
    }

    function itemsSelected(ev) {
      if (props.multiple === true) {
        const files = [];
        ev.target.files.forEach(file => {
          files.push(file);
        });
        context.emit("selected", files);
      } else {
        const file = ev.target.files[0];
        context.emit("selected", file);
      }

      fileInput.value.value = "";
    }
    function itemClicked(item, i) {
      context.emit("item-clicked", {
        item: item,
        index: i
      });
    }

    function deleteClicked(item, i) {
      context.emit("delete-item", {
        item: item,
        index: i
      });
    }

    function editClicked(item, i) {
      context.emit("edit-item", {
        item: item,
        index: i
      });
    }

    const containerType = computed(() => {
      return {
        "image-container": props.type === "images",
        "icon-container": props.type === "icons"
      };
    });

    const itemClass = computed(() => {
      return props.type === "images" ? "image" : "icon";
    });

    const buttonType = computed(() => {
      return props.type === "images" ? "image" : null;
    });

    return {
      fileInput,
      itemClicked,
      itemsSelected,
      containerType,
      itemClass,
      buttonType,
      plusClicked,
      deleteClicked,
      editClicked
    };
  }
};
</script>
